import { createContext, useContext } from "react";
import type { IPatientId } from "@medoma/models/patients";

export const TemplatesContext = createContext<{
  selectedPatientId: IPatientId;
  setSelectedPatientId: (patientId: IPatientId) => void;
  defaultStartDate: Date | undefined;
}>({
  selectedPatientId: "",
  setSelectedPatientId: () => {},
  defaultStartDate: undefined,
});

export const useTemplatesContext = () => {
  return useContext(TemplatesContext);
};
